<section class="whatsNew" id="articles">
  <div class="container">
    <div class="row">
      @if(articles() && articles().length>0){
        <h2 class="text-center"> What's New at Investing for Catholics</h2>
        <app-banner-slider>
          @for(article of articles(); track article.id) {
          <app-banner-card [class]="'bg-white h460'" [customBody]="true">
            <a class="d-block" routerLink="/articles/{{article.friendlyUrl.toLowerCase()}}">
              <img loading="lazy" width="285" height="160" src="{{article.posterUrl}}" alt="{{article.title}}">
            </a>
            <ng-container body>
              <div class="p-3 pt-1">
                <div class="ps-2 pt-0 font-open-1 font-14 text-end">{{article.date | date: "MMMM d, yyyy"}}</div>
                <div class="pt-2">
                  <h3 class="font-open font-18 card-title text-start mb-2"><a class=""
                      routerLink="/articles/{{article.friendlyUrl.toLowerCase()}}">{{article.title}}</a></h3>
                </div>
                <div class="teaser" [innerHTML]="article.teaser">
                </div>
              </div>
            </ng-container>
          </app-banner-card>
          }
        </app-banner-slider>
      }
    </div>
    <div class="row">
      <div class="mx-auto text-center mt-5">
        <a routerLink="/articles/" class="btn btn-primary btn-lg mx-auto">All Articles</a>
      </div>
    </div>
  </div>
</section>
